import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { deleteVisitProfile, getvisitProfile } from "../../actions/userActions/VisitProfileAction";
import SearchInput from "../subComponents/search/SearchInput";
import CustomButton from "../subComponents/buttons/CustomButton";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomPagination from "../subComponents/pagination/CustomPagination";
import Heading6Regular from "../designSystem/Heading6Regular";
import './VisitProfile.css';
import deleteIcon from "../../assets/images/deleteIcon_drawer.svg";
import Heading6Semibold from "../designSystem/Heading6Semibold";
import BodyMediumRegular from "../designSystem/BodyMediumRegular";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import thIcon from "../../assets/images/thIcon.svg";
import DynamicTable from "../reuse_components/DynamicTable";
import {
    DEFAULT_PAGE,
    DEFAULT_PAGE_SIZE,
    DEFAULT_SEARCH,
} from '../../Constatns';
import { PERMISSIONS } from "../../Permissions";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

const VisitProfile = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const visitProfile = useSelector((state) => state.visitProfile_reducer.visitProfile);
    const assigneeListRef = useRef(null);
    const permissions = JSON.parse(localStorage.getItem("permissionsList"));
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedVisitProfileId, setSelectedVisitProfileId] = useState(null);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [isReady, setIsReady] = useState(false);
    const modalRef = useRef(null);
    const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_PAGE_SIZE);
    const isLoading = useSelector((state) => state.visitProfile_reducer.isVisitProfileLoading);
    useEffect(() => {
        if (location.state?.returnToVisitProfile) {
            setCurrentPage(location.state.page || DEFAULT_PAGE);
            setSearchQuery(location.state.search || DEFAULT_SEARCH);
            setItemsPerPage(location.state.pageSize || DEFAULT_PAGE_SIZE);
        } else {
            const queryParams = new URLSearchParams(location.search);
            const pageParam = queryParams.get('page');
            const searchParam = queryParams.get('search');
            const pageSizeParam = queryParams.get('pageSize');

            if (pageParam) setCurrentPage(parseInt(pageParam));
            if (searchParam) setSearchQuery(searchParam);
            if (pageSizeParam) setItemsPerPage(parseInt(pageSizeParam));
        }

        setIsReady(true);
    }, [location]);
    useEffect(() => {
        if (!isReady) return;

        const params = new URLSearchParams();
        params.set('page', currentPage);
        params.set('pageSize', itemsPerPage);
        if (searchQuery) params.set('search', searchQuery);

        const newSearch = params.toString() ? `?${params.toString()}` : '';
        if (location.search !== newSearch) {
            history.replace({
                pathname: location.pathname,
                search: newSearch
            });
        }
        dispatch(getvisitProfile(currentPage, itemsPerPage, searchQuery));
    }, [currentPage, searchQuery, itemsPerPage, isReady]);
    const handleItemsPerPageChange = (value) => {
        setItemsPerPage(value);
        setCurrentPage(1);
        dispatch(getvisitProfile(1, value, searchQuery));
    };
    const handleAddVisitProfileClick = () => {
        history.push({
            pathname: '/admin/AddVisitProfile',
            state: {
                fromVisitProfile: true,
                page: currentPage,
                search: searchQuery,
                pageSize: itemsPerPage
            }
        });
    };
    const handleEditVisitProfile = (row) => {
        history.push({
            pathname: '/admin/UpdateVisitProfile',
            visitProfile: { row },
            id: row.visitProfileId,
            state: {
                fromVisitProfile: true,
                page: currentPage,
                search: searchQuery,
                pageSize: itemsPerPage
            }
        });
    };
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (assigneeListRef.current && !assigneeListRef.current.contains(event.target)) {
                setExpandedRowId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleCancelDelete();
            }
        }

        if (openModal) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openModal]);

    const handleCancelDelete = () => {
        setOpenModal(false);
        setSelectedVisitProfileId(null);
    };

    const handleConfirmDelete = () => {
        if (selectedVisitProfileId) {
            dispatch(deleteVisitProfile(selectedVisitProfileId)).then(() => {
                dispatch(getvisitProfile(currentPage, itemsPerPage, searchQuery));
            });
        }
        setOpenModal(false);
        setSelectedVisitProfileId(null);
    };

    const handleOpenModal = (row) => {
        setSelectedVisitProfileId(row.visitProfileId);
        setOpenModal(true);
    };

    const totalPages = visitProfile?.totalPages || 0;
    const totalItems = visitProfile?.totalCount || 0;

    const columns = [
        { label: `${t("name")}`, accessor: 'systemGeneratedName' },
        { label: `${t("displayName")}`, accessor: 'profileName' },
        { label: `${t("city")}`, accessor: 'cityName' },
        { label: `${t("assignedTo")}`, accessor: 'assigneesDisplay' },
        { label: `${t("createdBy")}`, accessor: 'createdByDisplay' }
    ];

    const toggleAssigneeList = (rowId, event) => {
        event.stopPropagation();
        setExpandedRowId(expandedRowId === rowId ? null : rowId);
    };

    const processedData = (visitProfile?.result || []).map(item => {
        const processedItem = { ...item };
        const rowId = item.visitProfileId;
        const isExpanded = expandedRowId === rowId;

        if (item.assignees && Array.isArray(item.assignees) && item.assignees.length > 0) {
            if (item.assignees.length === 1) {
                const assignee = item.assignees[0];
                processedItem.assigneesDisplay = (
                    <div className="assignee-single">
                        <div className="assignee-details">
                            <div className="assignee-name">{assignee.name}</div>
                            {assignee.designationName && (
                                <div className="assignee-designation">{assignee.designationName}</div>
                            )}
                        </div>
                    </div>
                );
            } else {
                processedItem.assigneesDisplay = (
                    <div className="assignees-container">
                        <div className="avatars-row">
                            {item.assignees.slice(0, 3).map((assignee, index) => {
                                const isLastVisibleAvatar =
                                    (index === item.assignees.length - 1 && item.assignees.length <= 3 && item.assignees.length > 1);

                                return (
                                    <div
                                        key={assignee.id}
                                        className={`avatar-circle ${isLastVisibleAvatar ? 'last-avatar' : ''}`}
                                        style={{
                                            left: `${index * 22}px`,
                                            zIndex: 10 - index,
                                            cursor: isLastVisibleAvatar ? 'pointer' : 'default'
                                        }}
                                        title={assignee.name}
                                        onClick={(e) => isLastVisibleAvatar && toggleAssigneeList(rowId, e)}
                                    >
                                        {assignee.name.charAt(0).toUpperCase()}
                                    </div>
                                );
                            })}

                            {item.assignees.length > 3 && (
                                <div
                                    className="avatar-counter"
                                    style={{ left: `${3 * 22}px`, cursor: 'pointer' }}
                                    onClick={(e) => toggleAssigneeList(rowId, e)}
                                >
                                    +{item.assignees.length - 3}
                                </div>
                            )}
                        </div>

                        {isExpanded && (
                            <div
                                className="assignees-expanded"
                                ref={assigneeListRef}
                            >
                                <div className="assignees-list">
                                    {item.assignees.map(assignee => (
                                        <div key={assignee.id} className="assignee-item">
                                            <div className="assignee-avatar">
                                                {assignee.name.charAt(0).toUpperCase()}
                                            </div>
                                            <div className="assignee-details">
                                                <div className="assignee-name">{assignee.name}</div>
                                                {assignee.designationName && (
                                                    <div className="assignee-designation">{assignee.designationName}</div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            }
        } else {
            processedItem.assigneesDisplay = (
                <span style={{ color: '#999' }}>Not available</span>
            );
        }
        if (item.createdBy && item.createdBy.name && item.createdBy.name.trim() !== "") {
            processedItem.createdByDisplay = item.createdBy.name;
        } else {
            processedItem.createdByDisplay = (
                <span style={{ color: '#999' }}>Not available</span>
            );
        }
        if (!item.systemGeneratedName) {
            processedItem.systemGeneratedName = (
                <span style={{ color: '#999' }}>Not available</span>
            );
        }
        return processedItem;
    });

    const actions = [
        {
            label: 'Delete Visit Profile',
            icon: <DeleteOutlineIcon sx={{color: "#FD511B"}} />,
            permission: 'CanDeleteVisitProfile',
            handler: handleOpenModal,
        },
        {
            label: 'Edit Visit Profile',
            icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
            permission: 'CanUpdateVisitProfile',
            handler: handleEditVisitProfile,
        },
    ];

    return (
        <>
            <div>
                <LoadingOverlay isVisible={isLoading} />
                <div className="main-container">
                     <div className="content-wrapper">
                        <div className="pagination">
                            <SearchInput
                                placeholder="Search"
                                onChange={handleSearchChange}
                                value={searchQuery || ""}
                            />
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ minWidth: '80px', marginRight: '10px' }}>
                                    <ItemsPerPageSelector
                                        value={itemsPerPage}
                                        onChange={handleItemsPerPageChange}
                                    />
                                </div>
                                <CustomPagination
                                    currentPage={currentPage}
                                    totalItems={totalItems}
                                    itemsPerPage={itemsPerPage}
                                    totalPages={totalPages}
                                    onPageChange={(page) => setCurrentPage(page)}
                                />
                                {permissions && permissions.includes(PERMISSIONS.CAN_ADD_VISIT_PROFILE) && (
                                    <CustomButton
                                        text={t("addNew")}
                                        onClick={handleAddVisitProfileClick}
                                    />
                                )}
                            </div>
                        </div>
                     
                    </div>
                    <DynamicTable
                            data={processedData}
                            columns={columns}
                            permissions={permissions}
                            actions={actions}
                            thIcon={thIcon}
                            showPagination={totalItems > 0}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                            onItemsPerPageChange={handleItemsPerPageChange}
                        />
                     
                </div>
                {openModal && (
                    <div className="modal-backdrop">
                        <div className="modal-container" ref={modalRef}>
                            <div className='content-container'>
                                <div className='icon-container'>
                                    <img src={deleteIcon} />
                                </div>
                                <div className='text-container'>
                                    <Heading6Semibold color='#1E293B' text='Delete Visit Profile' />
                                    <BodyMediumRegular
                                        color='#384153'
                                        text='Are you sure you want to delete this visit profile?'
                                        textAlign='center'
                                    />
                                </div>
                            </div>
                            <div className='button-contiainer'>
                                <button className='cancel-button' onClick={handleCancelDelete}>
                                <p className="button-text">Cancel</p>
                                </button>
                                <button className='danger-button' onClick={handleConfirmDelete}>
                                <p className="button-text delete">Delete</p>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </>
    );
};

export default VisitProfile;